import { Link } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import ThemeToggle from "./common/ThemeToggle";

const FEATURE_LINKS = [
  { href: "#how-it-works", label: "How It Works" },
  { href: "#features", label: "Features" },
  { href: "#testimonials", label: "Testimonials" },
];

function Footer() {
  const { user } = useAuth();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-card-bg border-t border-card-border mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-8 mb-10">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-3" aria-label="GrowthTracker home">
              <div className="w-8 h-8 bg-gradient-to-br from-emerald-500 to-teal-600 rounded-xl flex items-center justify-center">
                <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
                </svg>
              </div>
              <span className="text-lg font-bold text-text-primary">GrowthTracker</span>
            </Link>
            <p className="text-sm text-text-secondary leading-relaxed">
              Helping families track and celebrate every milestone from birth to age 5.
            </p>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-text-primary mb-3 uppercase tracking-wider">Features</h3>
            <ul className="space-y-2">
              {FEATURE_LINKS.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="text-sm text-text-secondary hover:text-text-primary transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-text-primary mb-3 uppercase tracking-wider">App</h3>
            <ul className="space-y-2">
              {user ? (
                <>
                  <li>
                    <Link to="/dashboard" className="text-sm text-text-secondary hover:text-text-primary transition-colors">
                      Dashboard
                    </Link>
                  </li>
                  <li>
                    <Link to="/profile" className="text-sm text-text-secondary hover:text-text-primary transition-colors">
                      Profile
                    </Link>
                  </li>
                </>
              ) : (
                <>
                  <li>
                    <Link to="/register" className="text-sm text-text-secondary hover:text-text-primary transition-colors">
                      Get Started
                    </Link>
                  </li>
                  <li>
                    <Link to="/login" className="text-sm text-text-secondary hover:text-text-primary transition-colors">
                      Sign In
                    </Link>
                  </li>
                </>
              )}
            </ul>
          </div>
        </div>

        <div className="pt-6 border-t border-card-border flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-text-tertiary">
            © {currentYear} GrowthTracker. All rights reserved.
          </p>
          <ThemeToggle />
        </div>
      </div>
    </footer>
  );
}

export default Footer;
